const sources = import.meta.glob('../assets/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const urls = import.meta.glob('../assets/icons/*.svg', {
  import: 'default',
  eager: true,
}) as Record<string, string>;

/** CMS sends a bare filename, but tolerate a leading slash. */
const keyFor = (icon: string) => `../assets/icons/${icon.replace(/^\/+/, '')}`;

/** Fingerprinted URL for a product icon (e.g. `'vray.svg'`). */
export const productIcon = (icon: string): string => urls[keyFor(icon)] ?? '';

export const productIconColor = (icon: string): string =>
  sources[keyFor(icon)]?.match(/fill="(#[0-9a-fA-F]{3,8})"/)?.[1] ?? '';
